import React from 'react'
import { useSelector } from 'react-redux'
import Table from 'components/Table'
import { CONSTANTS } from 'constants/constants'
import { CAPACITY } from 'constants/forioVariables'
import { formatVariables } from 'common/utils'

const {
  ASSISTANS,
  DIRECTORS,
  PARTHERS,
  TAXES_AND_FINANCES,
  BIDDING_AND_GOVERMENT,
  TRIALS,
  REAL_STATE,
} = CONSTANTS

const {
  COLA_DE_HORAS_IYF_REGION_I_ASISTENTE_FINO,
  COLA_DE_HORAS_IYF_REGION_I_FINO_DIRECTORES,
  COLA_DE_HORAS_IYF_REGION_I_FINO_SOCIOS,

  COLA_DE_HORAS_LYG_REGION_I_ASISTENTE_FINO,
  COLA_DE_HORAS_LYG_REGION_I_FINO_DIRECTORES,
  COLA_DE_HORAS_LYG_REGION_I_FINO_SOCIOS,

  COLA_DE_HORAS_JUICIOS_REGION_I_ASISTENTE_FINO,
  COLA_DE_HORAS_JUICIOS_REGION_I_FINO_DIRECTORES,
  COLA_DE_HORAS_JUICIOS_REGION_I_FINO_SOCIOS,

  COLA_DE_HORAS_BRR_REGION_I_ASISTENTE_FINO,
  COLA_DE_HORAS_BRR_REGION_I_FINO_DIRECTORES,
  COLA_DE_HORAS_BRR_REGION_I_FINO_SOCIOS,
} = CAPACITY

const returnData = variables => [
  [
    ASSISTANS,
    variables[COLA_DE_HORAS_IYF_REGION_I_ASISTENTE_FINO],
    variables[COLA_DE_HORAS_LYG_REGION_I_ASISTENTE_FINO],
    variables[COLA_DE_HORAS_JUICIOS_REGION_I_ASISTENTE_FINO],
    variables[COLA_DE_HORAS_BRR_REGION_I_ASISTENTE_FINO],
  ],
  [
    DIRECTORS,
    variables[COLA_DE_HORAS_IYF_REGION_I_FINO_DIRECTORES],
    variables[COLA_DE_HORAS_LYG_REGION_I_FINO_DIRECTORES],
    variables[COLA_DE_HORAS_JUICIOS_REGION_I_FINO_DIRECTORES],
    variables[COLA_DE_HORAS_BRR_REGION_I_FINO_DIRECTORES],
  ],
  [
    PARTHERS,
    variables[COLA_DE_HORAS_IYF_REGION_I_FINO_SOCIOS],
    variables[COLA_DE_HORAS_LYG_REGION_I_FINO_SOCIOS],
    variables[COLA_DE_HORAS_JUICIOS_REGION_I_FINO_SOCIOS],
    variables[COLA_DE_HORAS_BRR_REGION_I_FINO_SOCIOS],
  ],
]
const columns = () => [
  { type: 'label', name: '' },
  { type: 'label', name: TAXES_AND_FINANCES },
  { type: 'label', name: BIDDING_AND_GOVERMENT },
  { type: 'label', name: TRIALS },
  { type: 'label', name: REAL_STATE },
]

const HoursToCarryThroughInCorporateSegment = () => {
  const variables = useSelector(
    state => state.capacity.currentValues.variablesHoursToCarryThroughInCorporateSegment,
  )
  const formattedVariables = formatVariables(variables)

  return (
    <Table
      titleTable="Hours of work pending in corporate segment"
      titleColor="#758C5E"
      columns={columns()}
      data={returnData(formattedVariables)}
    />
  )
}

export default HoursToCarryThroughInCorporateSegment
